// Polyfill for IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (document.querySelector('.lemonly .block-accordion')) {
    var accordions = document.querySelectorAll('.lemonly .block-accordion .accordion-toggle button');

    accordions.forEach(function (element) {
        element.addEventListener('click', function () {
            //  this.parentElement.classList.toggle('open');

            if (this.getAttribute('aria-expanded') === 'true') {
                this.setAttribute('aria-expanded', 'false');
                this.parentElement.parentElement.querySelector('.accordion-content').setAttribute('hidden', '');
            } else {
                this.setAttribute('aria-expanded', 'true');
                this.parentElement.parentElement.querySelector('.accordion-content').removeAttribute('hidden');
            }
        });
    });
}


window.addEventListener("hashchange", function () {
    var resourceAccordions = document.querySelectorAll('.lemonly #resources .block-accordion .accordion-toggle button');
    resourceAccordions.forEach(function (element) {
        element.setAttribute('aria-expanded', 'false');
        element.parentElement.parentElement.querySelector('.accordion-content').setAttribute('hidden', '');
    });

    if (window.location.hash) {
        var userUrl = window.location.href.split('#')[1];
        accordionHash();
    }
});


function accordionHash() {
    var accordions = document.querySelectorAll('.lemonly .block-accordion .accordion-toggle button');

    accordions.forEach(function (element) {
        if (element.id == userUrl) {
            element.setAttribute('aria-expanded', 'true');
            element.parentElement.parentElement.querySelector('.accordion-content').removeAttribute('hidden');
        }
    });
}